import {
  keepPreviousData as keepPreviousDataFn,
  useQuery,
} from '@tanstack/react-query'

import { TypesenseClientInstance } from '../typesenseClient'
import { getTypesenseAuctionsByIDs } from './getTypesenseAuctionsByIDs'

interface UseGetTypesenseAuctionsByIDsParams {
  client: TypesenseClientInstance
  auctionIds: number[]
  keepPreviousData: boolean
  enabled?: boolean
  staleTime?: number
  refetchOnMount?: boolean
  objectIDs?: never
}

export const useGetTypesenseAuctionsByIDs = ({
  client,
  auctionIds,
  keepPreviousData,
  enabled,
  staleTime,
  refetchOnMount,
}: UseGetTypesenseAuctionsByIDsParams) =>
  useQuery({
    queryKey: ['auctions', { auctionIds }],
    queryFn: () => getTypesenseAuctionsByIDs(client, auctionIds),
    placeholderData: keepPreviousData ? keepPreviousDataFn : undefined,
    enabled,
    staleTime,
    refetchOnMount,
  })
